import Tooltip from '@mui/material/Tooltip'
import IconButton from '@mui/material/IconButton'
import DeleteIcon from '@mui/icons-material/Delete'

const DeleteIconButtonBase = ({ children, ...iconProps }) => {
  return (
    <IconButton color="error" size="small" {...iconProps}>
      <DeleteIcon />
    </IconButton>
  )
}

export const DeleteIconButton = ({ showTooltip, tooltipTitle, children, ...iconProps }) => {
  return showTooltip ? (
    <Tooltip title={tooltipTitle}>
      <div>
        {/* This div is needed because a child of a Material-UI Tooltip must be able to hold a ref. 
        Otherwise the tooltip is not showed */}
        <DeleteIconButtonBase {...iconProps}>{children}</DeleteIconButtonBase>
      </div>
    </Tooltip>
  ) : (
    <DeleteIconButtonBase {...iconProps}>{children}</DeleteIconButtonBase>
  )
}
